import { useCallback } from "react";
import useTralentStore from "@/stores";
import { formatAmountWithSymbol } from "@tralent/frontend";

export const useCurrencyFormatter = () => {
    const {userCurrency} = useTralentStore();


    const amountWithUserCurrency = useCallback(
        (amount: number) =>
            formatAmountWithSymbol({
                value: amount,
                fixed: userCurrency.decimals,
                symbol: userCurrency.symbol,
            }),
        [userCurrency.decimals, userCurrency.symbol]
    );

    return { amountWithUserCurrency };
};
